export default {
  namespaced: true,
  state: {
    previewData: {
      type: '',
      dataList: [],
      dataCurrent: 0,
      details: {}
    }
  },
  mutations: {
    setPreviewData(state, data) {
      state.previewData = data
    },
  }
}
